import React from 'react';
import { Hammer, Package } from 'lucide-react';
import GenericSectionDashboard from '../GenericSectionDashboard';

const TissueDashboard = () => {
  const customTiles = [
    {
      id: 'tissue-hub',
      title: 'Job Work',
      description: 'Request greige sorts for the jobber, receive FG packs back',
      icon: Hammer,
      iconBg: 'bg-purple-600',
      route: '/sections/tissue/hub',
      testId: 'tissue-hub-tile',
      priority: true,
    },
    {
      id: 'tissue-assortment',
      title: 'Tissue Assortment',
      description: 'Box received FG packs for Internal Transfer',
      icon: Package,
      iconBg: 'bg-emerald-600',
      route: '/sections/tissue/assortment',
      testId: 'tissue-assortment-tile',
      priority: true,
    },
  ];

  return (
    <GenericSectionDashboard
      sectionName="Tissue Section"
      sectionId="tissue"
      sectionKey="Tissue"
      description="Tissue Product Handling & Processing"
      backRoute="/"
      customTiles={customTiles}
    />
  );
};

export default TissueDashboard;
